import api from './api.js';

/**
 * Health data service wrapper
 */
class HealthData {

  /**
     * Constructor
     */
  constructor() {
        
    // Set URLs
    this.url = '/account/health-data';
  }

  /**
     * Get all health data
     * @return {Promise}
     */
  all () {
    return api.get(this.url);
  }

  /**
     * Get specific health data by ID
     * @param {number} id 
     */
  get(id) {
    return api.get(this.url + '/' + id);
  }

  /**
     * Create new health data entry
     * @param {*} data 
     */
  create(data) {
    return api.post(this.url, data);
  }

  /**
     * Delete a particular health data entry
     * @param {number} id 
     */
  delete(id) {
    return api.delete(this.url + '/' + id);
  }
}

export default new HealthData;